import { render } from "./IconCancel.vue?vue&type=template&id=6af79d8c"
import script from "./IconCancel.vue?vue&type=script&lang=js"
export * from "./IconCancel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__